import axiosInstance from './axiosInstance';

export const fetchNotifications = (companyId) =>
	axiosInstance.get(`/notifications/${companyId}`).then((res) => res.data);

export const markNotificationAsRead = (id, employeeId) =>
	axiosInstance.put(`/notifications/${id}/read`, { employeeId });

export const markNotificationAsUnread = (id, employeeId) =>
	axiosInstance.put(`/notifications/${id}/unread`, { employeeId });

export const markAllNotificationsAsRead = (companyId, employeeId) =>
	axiosInstance.put(`/notifications/company/${companyId}/read-all`, { employeeId });

export const deleteNotification = (id, employeeId) =>
	axiosInstance.delete(`/notifications/${id}`, { data: { employeeId } });

export const deleteAllNotifications = (companyId, employeeId) =>
	axiosInstance.delete(`/notifications/company/${companyId}/delete-all`, {
		data: { employeeId },
	});
